module.exports = __webpack_public_path__ + "img/help_icon.4fc57296.svg";